export const MAX_ACCOUNT_EMAIL_ADDRESSES = 32;
export const MAX_ACCOUNT_EMAIL_LENGTH = 320;

export function decodeAccountEmailAddresses(value, label = "Account email addresses") {
  if (!Array.isArray(value) || value.length > MAX_ACCOUNT_EMAIL_ADDRESSES) {
    throw new TypeError(`${label} are invalid`);
  }
  const seen = new Set();
  const addresses = value.map((address, index) => {
    if (
      typeof address !== "string"
      || address.length < 3
      || address.length > MAX_ACCOUNT_EMAIL_LENGTH
      || address.trim() !== address
      || /[\u0000-\u001f\u007f]/u.test(address)
      || !address.includes("@")
    ) {
      throw new TypeError(`${label} entry ${index} is invalid`);
    }
    const key = address.toLowerCase();
    if (seen.has(key)) {
      throw new TypeError(`${label} contain a duplicate`);
    }
    seen.add(key);
    return address;
  });
  return Object.freeze(addresses);
}
